export const APP_VERSION = '25.10.5.1';

export const APP_TITLE = `IDE Missionários (${APP_VERSION})`;
